"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TYPE = void 0;
exports.TYPE = 'testFooter';
